import {useId} from "react";
import EditableAutoCompleteBase from "./EditableAutoCompleteBase";

const states = [
    {'abbr': 'AL'},
    {'abbr': 'AK'},
    {'abbr': 'AZ'},
    {'abbr': 'AR'},
    {'abbr': 'CA'},
    {'abbr': 'CO'},
    {'abbr': 'CT'},
    {'abbr': 'DE'},
    {'abbr': 'DC'},
    {'abbr': 'FL'},
    {'abbr': 'GA'},
    {'abbr': 'HI'},
    {'abbr': 'ID'},
    {'abbr': 'IL'},
    {'abbr': 'IN'},
    {'abbr': 'IA'},
    {'abbr': 'KS'},
    {'abbr': 'KY'},
    {'abbr': 'LA'},
    {'abbr': 'ME'},
    {'abbr': 'MD'},
    {'abbr': 'MA'},
    {'abbr': 'MI'},
    {'abbr': 'MN'},
    {'abbr': 'MS'},
    {'abbr': 'MO'},
    {'abbr': 'MT'},
    {'abbr': 'NE'},
    {'abbr': 'NV'},
    {'abbr': 'NH'},
    {'abbr': 'NJ'},
    {'abbr': 'NM'},
    {'abbr': 'NY'},
    {'abbr': 'NC'},
    {'abbr': 'ND'},
    {'abbr': 'OH'},
    {'abbr': 'OK'},
    {'abbr': 'OR'},
    {'abbr': 'PA'},
    {'abbr': 'PR'},
    {'abbr': 'RI'},
    {'abbr': 'SC'},
    {'abbr': 'SD'},
    {'abbr': 'TN'},
    {'abbr': 'TX'},
    {'abbr': 'UT'},
    {'abbr': 'VT'},
    {'abbr': 'VA'},
    {'abbr': 'WA'},
    {'abbr': 'WV'},
    {'abbr': 'WI'},
    {'abbr': 'WY'},
];

const EditableCardEntryState = ({isEditing, onEdit, baseValue, multiselect = false, requestSubmission = () => {}, displayLabel = "State"}) => {
    const randomId = useId();

    return <EditableAutoCompleteBase
        isEditing={isEditing}
        label={displayLabel}
        displayValue={multiselect ? (baseValue?.join(",") ?? "???") : baseValue}
        inputID={randomId}
        defaultValue={baseValue}
        items={states}
        idKey={"abbr"}
        nameKey={"abbr"}
        placeholder={displayLabel}
        onSelect={onEdit}
        multiSelect={multiselect}
        requestSubmission={requestSubmission}
    />;
}

export default EditableCardEntryState;